const MEDICATION_SECTION_LABELS = new Set([
  'the',
  'from',
  'active',
  'current',
  'current medications',
  'discontinued',
  'evening',
  'evening medications',
  'evening meds',
  'held',
  'medication',
  'medications',
  'morning',
  'morning medications',
  'morning meds',
  'notes',
  'prn',
  'stopped',
  'stopped medications',
]);

const normalizeWhitespace = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

export const isNumericMedicationName = (value = '') => /^\d+$/.test(normalizeWhitespace(value));

export const hasInvalidMedicationName = (name = '') => {
  const cleanName = normalizeWhitespace(name);
  const normalizedName = cleanName.toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  return !cleanName
    || MEDICATION_SECTION_LABELS.has(normalizedName)
    || isNumericMedicationName(cleanName)
    || /^(?:[-*•·]|\d+[.)])(?:\s|$)/.test(cleanName)
    || /['’]s$/i.test(cleanName);
};
